import { useEffect } from 'react';
import { useConfig } from '@/context/ConfigContext';

export function usePageTitle(title) {
  const config = useConfig();
  
  useEffect(() => {
    if (title && config?.AGENCY_NAME) {
      document.title = `${config.AGENCY_NAME} - ${title}`;
    } else if (config?.AGENCY_NAME) {
      document.title = config.AGENCY_NAME;
    } else {
      document.title = 'Artificialmente Scout';
    }
    
    // Opcional: restaurar el título original al desmontar si lo deseas
    return () => {
      if (config?.AGENCY_NAME) {
        document.title = config.AGENCY_NAME;
      } else {
        document.title = 'Artificialmente Scout';
      }
    };
  }, [title, config]);
};
